import script from "./SubastaLotes.vue?vue&type=script&setup=true&lang=js"
export * from "./SubastaLotes.vue?vue&type=script&setup=true&lang=js"

import "./SubastaLotes.vue?vue&type=style&index=0&id=1ab400a2&lang=css"

const __exports__ = script;

export default __exports__